import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import RegularButton from "../../components/Buttons/RegularButton";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  useGoogleAuthDetailsMutation,
  useLoginUserMutation,
  useSsoLoginUserMutation,
} from "../../redux/services/authApi";
import {
  getUserData,
  setUser,
} from "../../redux/slices/authSlice";
import { auth, facebook, google, twitter } from "../../config/firebase";
import {
  FacebookAuthProvider,
  GoogleAuthProvider,
  signInWithPopup,
  TwitterAuthProvider,
} from "firebase/auth"
import toast from "react-hot-toast";
import { useFindCustomerDetailByIdMutation } from "../../redux/services/customerService";
import * as Yup from "yup";
import { setCustomer } from "../../redux/slices/customerSlice";
import MuiAlert from "../../pages/MuiAlert/MuiAlert";
import Google from "../../assets/Google.png";
import Facebook from "../../assets/FB.png";
import Loading from "../../pages/commons/Loading";
import { tagManager } from "../../redux/services/utility";

type Props = {
  navigation?: any;
  route?: any;
};

const SignInSchema = Yup.object().shape({
  username: Yup.string().max(40).required(" Email is required"),
  password: Yup.string()
    .required("Password is required")
    .min(6, "Password is too short"),
});

const Login = (props: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loginUser, loginResponse] = useLoginUserMutation();
  const [ssoLoginUser, ssoLoginResponse] = useSsoLoginUserMutation();
  const [googleAuthDetails, googleAuthResponse] =
    useGoogleAuthDetailsMutation();
  const location: any = useLocation();
  const [authenticationData, setAuthenticationData] = useState<null | any>(
    null
  );
  const [googleData, setGoogleData] = useState<null | any>(null);
  const userData = useSelector(getUserData);
  const [findCustomerDetailById, findByIdResponse] =
    useFindCustomerDetailByIdMutation();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);

  const handleLogin = (values: any) => {
    loginUser({
      username: values.username,
      password: values.password,
      category: "UTCUST",
    });
  };

  const loginWithSocialMedia = (
    email: string,
    name: string,
    gaccessToken: string,
    // gidToken: string,
    gid: string,
    gpicture: string
  ) => {
    ssoLoginUser({
      email: email,
      name: name,
      gaccessToken: gaccessToken,
      gid: gid,
      // gidToken: gidToken ,
      gimageUrl: gpicture,
    });
    tagManager("LOGIN_GOOGLE", email)
  };

  const SignInWithGoogle = () => {
    tagManager("LOGIN_GOOGLE")

    let google_provider = google;
    signInWithPopup(auth, google_provider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        console.log(credential ,"credential");
        const token = credential?.accessToken;
        setAuthenticationData(credential);
        const user = result.user;
        setGoogleData(user);
        if (result.user.emailVerified === true) {
          googleAuthDetails({
            token: token,
          });
        }
      })
      .catch((error) => {
        toast.success(error.code, error.message);
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.customData.email;
        const credential = GoogleAuthProvider.credentialFromError(error);
      });
  };

  // const SignInWithFaceBook = () => {
  //   console.log("in function sign in with face book")
  //   tagManager("LOGIN_FACEBOOK")
  //   const facebook_provider = facebook;
  //   signInWithPopup(auth, facebook_provider)
  //     .then((result) => {
  //       console.log(result ,"result");
  //       const user = result.providerId;
  //       console.log(user ,"user");
  //       const credential = FacebookAuthProvider.credentialFromResult(result);
  //       console.log(credential ,"credential");
  //       if (credential?.accessToken !== null) {
  //         ssoLoginUser({
  //           email: result?.user?.providerData?.[0]?.email,
  //           name: result?.user?.displayName,
  //           fbAccessToken: credential?.accessToken,
  //           fbId: credential?.idToken,
  //           fbImageUrl: result?.user?.photoURL,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       toast.success(error.code, error.message);
  //       const errorCode = error.code;
  //       const errorMessage = error.message;
  //       const credential = FacebookAuthProvider.credentialFromError(error);
  //     });
  // };


  const SignInWithFaceBook = () => {
    console.log("In function sign in with Facebook");
    tagManager("LOGIN_FACEBOOK");
  
    signInWithPopup(auth, facebook)
      .then((result) => {
        console.log("Result from Facebook login:", result);
  
        const user = result.user;
        const credential = FacebookAuthProvider.credentialFromResult(result);
        const accessToken = credential?.accessToken;
  
        if (accessToken) {
          const profile = user.providerData[0];
          console.log("User Profile Data:", profile);
  
          ssoLoginUser({
            email: profile?.email,
            name: user.displayName,
            fbAccessToken: accessToken,
            fbId: profile?.uid, // or use result.additionalUserInfo.profile.id
            fbImageUrl: user.photoURL,
          });
        } else {
          console.warn("No access token returned from Facebook.");
        }
      })
      .catch((error) => {
        console.error("Facebook login error:", error);
        toast.error(`${error.code}: ${error.message}`);
      });
  };
  

  const SignInWithTwitter = () => {
    tagManager("LOGIN_TWITTER")
    const twitter_provider = twitter;
    signInWithPopup(auth, twitter_provider)
      .then((result) => {
        const credential = TwitterAuthProvider.credentialFromResult(result);
        setAuthenticationData(credential?.accessToken);
        const token = credential?.accessToken;
        const secret = credential?.secret;
        const user = result.user;
        if (credential?.accessToken !== null) {
          ssoLoginUser({
            email: result?.user?.providerData?.[0]?.email,
            name: result?.user?.displayName,
            taccessToken: authenticationData?.accessToken,
            tid: authenticationData?.idToken,
            timageUrl: result?.user?.photoURL,
          });
        }
      })
      .catch((error) => {
        toast.success(error.code, error.message);
        const errorCode = error.code;
        const errorMessage = error.message;
        const credential = TwitterAuthProvider.credentialFromError(error);
      });
  };

  useEffect(() => {
    if (googleAuthResponse.isSuccess) {
      console.log(googleAuthResponse ,"googleAuthResponse");
      loginWithSocialMedia(
        googleData?.email,
        googleAuthResponse.data.name,
        authenticationData?.accessToken,
        // authenticationData?.idToken,
        googleAuthResponse.data.sub,
        googleAuthResponse.data.picture
      );
    } else if (googleAuthResponse.isError) {
      toast.success("Error ocurred");
    }
  }, [googleAuthResponse.isSuccess, googleAuthResponse.isError]);

  useEffect(() => {
    if (loginResponse.isSuccess) {
      toast.success("Successfully logged in");
      dispatch(setUser(loginResponse.data));
      localStorage.setItem("user", JSON.stringify(loginResponse.data));
      localStorage.setItem("isLoggedIn", "true");

      // Retrieve stored path and clear it after use
      const previousPath = localStorage.getItem("redirectAfterLogin") || "/";
      console.log(previousPath, "previousPath");
      // localStorage.removeItem("redirectAfterLogin");

      // Navigate to the stored path or home
      navigate(previousPath);
    }

    if (loginResponse.isError) {
      let errorData: any = loginResponse.error;
      let errorCode: any = errorData.data.serviceErrors[0]?.errorCode;

      setStatusCode({
        type: "error",
        code: errorCode === "USER_DISABLED" ? "USER_DISABLED" : "INVALID_CREDENTIALS",
      });

      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [loginResponse.isSuccess, loginResponse.isError]);




  useEffect(() => {
    if (loginResponse.isSuccess) {
      if (loginResponse.data.categoryType !== "UTCUST") {
        navigate("/profile/auth/login");
      } else {
        toast.success("Succesfully logged in ");
        dispatch(setUser(loginResponse.data));
        localStorage.setItem("user", JSON.stringify(loginResponse.data));
        localStorage.setItem("isLoggedIn", "true");
        const previousPath:any = localStorage.getItem("redirectAfterLogin");
        console.log(previousPath, "previousPath");
        // localStorage.removeItem("redirectAfterLogin");

        // Navigate to the stored path or home
        navigate(previousPath);
      }
    } else if (loginResponse.isError) {
      let errorData: any = loginResponse.error;
      let errorCode: any = errorData.data.serviceErrors[0].errorCode;
      setStatusCode({
        type: "error",
        code:
          errorCode == "USER_DISABLED"
            ? "USER_DISABLED"
            : "INVALID_CREDENTIALS",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
    if (ssoLoginResponse.isSuccess) {
      toast.success("Succesfully logged in ");
      dispatch(setUser(ssoLoginResponse.data));
      localStorage.setItem("user", JSON.stringify(ssoLoginResponse.data));
      localStorage.setItem("isLoggedIn", "true");
      const previousPath:any = localStorage.getItem("redirectAfterLogin") ;
      console.log(previousPath, "previousPath");
      // localStorage.removeItem("redirectAfterLogin");
      // Navigate to the stored path or home
      navigate(previousPath);
    } else if (ssoLoginResponse.isError) {
      toast.success("Invalid username or password");
      let errorData: any = ssoLoginResponse.error;
      let errorCode: any = errorData.data.serviceErrors[0].errorCode;
      setStatusCode({
        type: "error",
        code: "SOCIALMEDIA_ERROR",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [
    loginResponse.isSuccess || loginResponse.isError,
    ssoLoginResponse.isSuccess || ssoLoginResponse.isError,
  ]);


  useEffect(() => {
    if (userData) {
      findCustomerDetailById({
        token: token,
        id: userData.customerId,
      });
    }
  }, [userData]);
  useEffect(() => {
    if (findByIdResponse.isSuccess) {
      dispatch(setCustomer(findByIdResponse.data));
      localStorage.setItem(
        "customerDetail",
        JSON.stringify(findByIdResponse.data)
    );
    }
    if (findByIdResponse.isError) {
    }
  }, [findByIdResponse.isSuccess, findByIdResponse.isError]);


  return (
    <div className="w-full bg-[#F9F4EF]">
      <div className="relative w-full flex lg:hidden justify-center items-center pt-10">
        <img
          src={require("../../assets/login.png")}
          className="w-full sm:w-[500px] md:w-[600px]  md:max-h-[500px] object-cover"
          alt="Auth Illustration"
        />

        {/* Overlayed Text (Responsive for Mobile & Tab) */}
        <div className="absolute top-12 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center w-full px-4">
          <h2 className="text-xl sm:text-2xl md:text-4xl text-black">WEEKEND GETAWAY</h2>
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold text-black mt-2">
            Grab Up to 40% OFF*
          </h1>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row h-screen">
        {/* Form Section */}
        <div className="w-full lg:w-[40%] flex flex-col justify-center items-center p-4">
          <div className="max-w-[400px] w-full">
            {isAlertVisible && (
              <MuiAlert severity={statusCode?.type} messageType={statusCode?.code} />
            )}
            <div className="text-center">
              <h1 className="text-4xl font-bold text-gray-700">
                ca<span className="font-extrabold">RENT</span>al
              </h1>
              <h2 className="text-2xl font-semibold text-black mt-2">Sign in</h2>
            </div>
            <Formik validationSchema={SignInSchema}
              initialValues={{ username: "", password: "" }}
              onSubmit={handleLogin}>
              {({ handleChange, handleSubmit, errors, values, touched }) => (
                <div className="flex flex-col">
                  {/* Email Field */}
                  <div className="mt-3">
                    <TextField
                      label="Email"
                      variant="outlined"
                      type="text"
                      id="username"
                      name="username"
                      value={values.username}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      className="w-full"
                      error={Boolean(touched.username && errors.username)}
                      helperText={touched.username && errors.username}
                      sx={{
                        backgroundColor: "#E2E2E2",
                        borderRadius: "30px",
                        mb: 2,
                        height: "45px", // Slightly reduced height for a compact look
                        "& .MuiInputBase-root": {
                          display: "flex",
                          alignItems: "center", // Centers input text vertically
                          height: "100%",
                          padding: "0 12px", // Reducing padding inside input container
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "30px",
                          height: "100%",
                          "& input": {
                            padding: "6px 8px", // Reduced padding inside input field
                          },
                          "& fieldset": { borderColor: "transparent" },
                          "&:hover fieldset": { borderColor: "transparent" },
                          "&.Mui-focused fieldset": { borderColor: "transparent" },
                        },
                        "& .MuiInputLabel-root": {
                          top: "50%",
                          left: "12px", // Moves label closer to start
                          transform: "translateY(-50%)", // Centers label vertically
                        },
                        "& .MuiInputLabel-shrink": {
                          top: 6, // Moves label up when focused
                          transform: "translateY(-100%) scale(0.75)",
                        },
                        "& .MuiFormHelperText-root": {
                          position: "absolute",
                          bottom: "-18px", // Adjusted for better spacing
                          fontSize: "12px",
                          color: "red",
                        },
                      }}

                    />
                  </div>
                  {/* Password Field */}
                  <div className="mt-3">
                    <TextField
                      label="Password"
                      variant="outlined"
                      type="password"
                      id="password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      placeholder="Enter your password"
                      className="w-full"
                      error={Boolean(touched.password && errors.password)}
                      helperText={touched.password && errors.password}
                      sx={{
                        backgroundColor: "#E2E2E2",
                        borderRadius: "30px",
                        mb: 2,
                        height: "45px", // Slightly reduced height for a compact look
                        "& .MuiInputBase-root": {
                          display: "flex",
                          alignItems: "center", // Centers input text vertically
                          height: "100%",
                          padding: "0 12px", // Reducing padding inside input container
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "30px",
                          height: "100%",
                          "& input": {
                            padding: "6px 8px", // Reduced padding inside input field
                          },
                          "& fieldset": { borderColor: "transparent" },
                          "&:hover fieldset": { borderColor: "transparent" },
                          "&.Mui-focused fieldset": { borderColor: "transparent" },
                        },
                        "& .MuiInputLabel-root": {
                          top: "50%",
                          left: "12px", // Moves label closer to start
                          transform: "translateY(-50%)", // Centers label vertically
                        },
                        "& .MuiInputLabel-shrink": {
                          top: 6, // Moves label up when focused
                          transform: "translateY(-100%) scale(0.75)",
                        },
                        "& .MuiFormHelperText-root": {
                          position: "absolute",
                          bottom: "-18px", // Adjusted for better spacing
                          fontSize: "12px",
                          color: "red",
                        },
                      }}
                    />
                  </div>
                  {/* Login Button */}
                  <RegularButton
                    onClick={() => {
                      handleSubmit();
                    }}
                    className="w-full mt-1"
                    title={" Login"}
                  />
                  {/* Forgot Password */}
                  <div className="text-center mt-3 text-gray-500">
                    Forgot your password?{" "}
                    <span className="text-blue-500 cursor-pointer" onClick={() => navigate("/profile/auth/forget-password")}>
                      Click here
                    </span>
                  </div>
                  {/* OR Divider */}
                  <div className="flex items-center justify-center mt-3">
                    <p className="text-gray-500">Or Sign in with</p>
                  </div>
                  {/* Social Login Buttons */}
                  <div className="flex justify-center mt-3 gap-4 ">
                    <button className="h-9 w-9 flex items-center justify-center" onClick={SignInWithGoogle}>
                      <img src={Google} alt="Google" />
                    </button>
                    <button className="h-9 w-9 flex items-center justify-center" onClick={SignInWithFaceBook}>
                      <img src={Facebook} alt="Facebook" />
                    </button>
                  </div>
                  {/* Sign Up Link */}
                  <p className="text-center text-gray-500 mt-6">
                    Don't have an account yet?{" "}
                    <span className="text-blue-500 cursor-pointer" onClick={() => navigate("/profile/auth/signUp")}>
                      Sign up
                    </span>
                  </p>
                </div>
              )}
            </Formik>
          </div>
        </div>
        {/* Image Section */}
        <div className="relative w-full lg:w-[60%] hidden lg:flex justify-center items-center p-4">
          <img
            src={require("../../assets/login.png")}
            className="w-[600px] max-h-[300px] md:max-h-[500px] object-cover"
            alt="Auth Illustration"
          />

          {/* Overlayed Text (Centered Properly) */}
          <div className="absolute top-28 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center w-full px-4">
            <h2 className="text-4xl text-black whitespace-nowrap">WEEKEND GETAWAY</h2>
            <h1 className="text-5xl font-bold text-black mt-2 whitespace-nowrap">
              Grab Up to 40% OFF*
            </h1>
          </div>
        </div>

        {(loginResponse?.isLoading || findByIdResponse?.isLoading) && <Loading />}
      </div>
    </div>
  );
};
export default Login;
